import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';
import { PrimeNGConfig } from 'primeng/api';

import { firstValueFrom } from 'rxjs';
import { BASE_URL } from "@jwt";

import { CustomMessagesService } from './custom-messages.service';

@Injectable({
    providedIn: 'root',
})
export class LocalizationService {
    private customMsgService: CustomMessagesService;

    constructor(
        @Inject(BASE_URL) private baseUrl: string,
        @Inject(LOCALE_ID) public localeId: string,
        private primengConfig: PrimeNGConfig,
        private httpClient: HttpClient,
        public intlService: IntlService,
        messages: MessageService) {
        this.customMsgService = messages as CustomMessagesService;
    }

    public setLanguage(langId: any): void {
        const url = `${this.baseUrl}/common/setLanguage?langId=${langId}`;

        firstValueFrom(this.httpClient.get(url))
            .then(_ => {
                window.location.reload();
            })
            .catch(err => {
                console.error(`Failed to setLanguage(). Make sure ${url} is accessible.`, langId);
                return Promise.reject(err);
            });
    }

    public setLocalization(locale: string): void {
        this.localeId = locale;
        (this.intlService as CldrIntlService).localeId = locale;

        this.customMsgService.language = locale;

        this.primengConfig.ripple = true;
        fetch(`/assets/i18n/primeng/${locale}.json`).then(res => res.json())
            .then(json => {
                this.primengConfig.setTranslation(json);
            });
    }

    public translate(key: string): string {
        return this.customMsgService.translate(key);
    }

    private isDefined(value: any): boolean {
        return typeof value !== 'undefined' && value !== null;
    }

    public translateWithParams(key: string, ...args: any[]): any {
        if (!key || !key.length) {
            return key;
        }

        const value = this.customMsgService.translate(key);

        if (this.isDefined(args[0]) && args.length) {
            return value.replace(/{(\d+)}/g, (_, index) => args[index] || '')
        }

        return value;
    }
}
